import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useFormatMessage } from "../Intl/Context";
import Icon from "../Utils/Icon";

const FormPageCorrectionLegend = props => {
  const className = classNames("form-page-correction-legend", props.className);

  const t = useFormatMessage();
  const answersLegendTitle = t(intlMessages.answersLegendTitle);
  const viewerAnswersLegend = t(intlMessages.viewerAnswersLegend);
  const correctAnswersLegend = t(intlMessages.correctAnswersLegend);
  const incorrectAnswersLegend = t(intlMessages.incorrectAnswersLegend);

  return (
    <div className={className}>
      <h2 className="margin-bottom-sm text-title-section">{answersLegendTitle}</h2>
      <p className="form-page-correction-legend-viewer-answers">{viewerAnswersLegend}</p>

      <p className="form-page-correction-legend-correct-answers">
        <Icon className="fa fa-fw fa-check text-success margin-right-xs" />

        {correctAnswersLegend}
      </p>

      <p className="form-page-correction-legend-incorrect-answers">
        <Icon className="fa fa-fw fa-times text-danger margin-right-xs" />

        {incorrectAnswersLegend}
      </p>
    </div>
  );
};

export default FormPageCorrectionLegend;

const intlMessages = defineMessages({
  answersLegendTitle: {
    id: "formPage.answersLegendTitle",
    defaultMessage: "Légende de la correction"
  },
  viewerAnswersLegend: {
    id: "formPage.viewerAnswersLegend",
    defaultMessage: "Vos choix sont indiqués en gras et en bleu et encadrés en bleu"
  },
  correctAnswersLegend: {
    id: "formPage.correctAnswersLegend",
    defaultMessage: "Les bonnes réponses sont notées avec une coche verte"
  },
  incorrectAnswersLegend: {
    id: "formPage.incorrectAnswersLegend",
    defaultMessage: "Vos mauvaises réponses sont notées avec une croix rouge"
  }
});
